<script lang="ts">
    import type { Ranges } from "../interfaces/ranges";
    import type { Schedule } from "../interfaces/schedule";

    type ScheduleItem = {
        weekDays: string;
        ranges: Ranges[];
    };

    export let schedule: Schedule;

    const daysOrder = [1, 2, 3, 4, 5, 6, 0];

    let scheduleItems: ScheduleItem[] = [];

    $: buildSchedule(schedule);

    function buildSchedule(schedule: Schedule): void {

        scheduleItems = [];

        const copy: Schedule[] = JSON.parse(JSON.stringify(schedule));

        //Ordenamos los dias de horario de manera que el primer día sea el lunes
        copy.sort((a, b) => daysOrder.indexOf(a.index) - daysOrder.indexOf(b.index));

        //Creamos un mapa que use un hash del horario como clave
        //y un array de ScheduleDate como valor para detectar
        //días con el mismo horario
        const scheduleDatesMap = new Map<string, Schedule[]>();

        for (const scheduleDate of copy) {
            for (let i = 0; i < scheduleDate.ranges.length; i++) {
                const range = scheduleDate.ranges[i];
                
                if (!range.enabled) {
                    scheduleDate.ranges.splice(i, 1)
                }        
            }
        }
        
        for (const scheduleDate of copy) {
            //Ordenamos los rangos de horario de manera ascendente
            scheduleDate.ranges.sort((a, b) => {
                if (a.from < b.from) return -1;
                if (a.from > b.from) return 1;
                if (a.until < b.until) return -1;
                if (a.until > b.until) return 1;
                return 0;
            });

            //Creamos el hash
            const scheduleDateHash = scheduleDate.ranges.map(({ from, until }) => `${from}-${until}`).join(',');
            if (!scheduleDatesMap.has(scheduleDateHash)) {
                scheduleDatesMap.set(scheduleDateHash, []);
            }
            scheduleDatesMap.get(scheduleDateHash)!.push(scheduleDate);
        }

        const weekDayFormater = new Intl.DateTimeFormat([], {
            weekday: 'long'
        });

        for (const scheduleDates of scheduleDatesMap.values()) {
            let weekDays: string;
            if (scheduleDates.length > 2 && scheduleDatesAreConsecutives(scheduleDates)) {
                const firstDayName = weekDayFormater.format(getDateInWeekDay(scheduleDates[0].index));
                const lastDayName = weekDayFormater.format(getDateInWeekDay(scheduleDates.slice(-1)[0].index));
                weekDays = `${firstDayName} - ${lastDayName}`;
            } else {
                weekDays = scheduleDates.map(({ index }) => weekDayFormater.format(getDateInWeekDay(index))).join(', ');
            }

            const [scheduleDate] = scheduleDates;
            scheduleItems.push({
                weekDays,
                ranges: scheduleDate.ranges,
            });
        }

    }

    function scheduleDatesAreConsecutives(scheduleDates: Schedule[]): boolean {
        let prevDayIndex: number;
        return scheduleDates.every(({ index }) => {
            const consecutives = (prevDayIndex === undefined)
                ? true
                : (daysOrder.indexOf(index) - daysOrder.indexOf(prevDayIndex)) === 1;
            prevDayIndex = index;
            return consecutives;
        });
    }

    function getDateInWeekDay(index: number): Date {
        const date = new Date();
        date.setDate(date.getDate() - date.getDay() + index);
        return date;
    }

</script>

<div class="schedule">
    {#each scheduleItems as { weekDays, ranges }}
        <div class="schedule-item">
            <div class="week-days">{weekDays}</div>
            <div class="ranges">
                {#each ranges as { from, until }}
                    <div class="range">{from}-{until}</div>
                {/each}
                {#if ranges.length === 0}
                    <p>Cerrado</p>
                {/if}
            </div>
        </div>
    {/each}
</div>

<style lang="scss">

    .schedule{
        font-size: 15px;
        padding: 0px 10px;
    }

    .schedule-item {
        display: flex;
        justify-content: space-between;
    }

    .ranges {
        display: flex;
        gap: 0.5rem;
    }

    .range {
        white-space: nowrap;
    }

</style>
